import styled from 'styled-components';

export const ModalTitle = styled.h3`
  width: 100%;
  text-align: center;
  padding-bottom: 12px;
  border-bottom: 1px solid #888888;
`;

export const ModalText = styled.p`
  text-align: center;
`;

export const ContentContainer = styled.div`
  > div {
    max-height: 300px;
    overflow-y: auto !important;
  }
`;
